import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';

import vueI18n from '@/plugins/vue-i18n';

import 'dayjs/locale/fr-ca';
import 'dayjs/locale/en';

dayjs.extend(localizedFormat);

// https://github.com/iamkun/dayjs/tree/dev/src/locale
const getLocale = () => {
  if (/(.+[;,])?(fr|FR)([_|-])?.*/.test(vueI18n.locale)) {
    return 'fr-ca';
  }

  if (/(.+[;,])?(en|EN)([_|-])?.*/.test(vueI18n.locale)) {
    return 'en';
  }

  throw new Error('Invalid locale langue');
};

export default (date, format) => dayjs(date).locale(getLocale()).format(format);
